module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Label":"Create"},"fr":{"Label":"Créer"}}')
  delete Component.options._Ctor
}
